import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const Header = ({ title, actions, middle }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: { xs: 2, md: 3 },
          py: 1.5,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(20px)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          mb: 3,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography 
            variant="h5" 
            sx={{ 
              fontWeight: 700, 
              color: '#ffffff',
              textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
              fontSize: { xs: '1.25rem', md: '1.5rem' },
            }}
          >
            {title}
          </Typography>
          {middle}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: { xs: 1, md: 3 } }}>
          {actions}
        </Box>
      </Box>
    </motion.div>
  );
};

export default Header;
